import {
  getOutcomeValueAndLabel
} from "../entities/outcome.js";
import {
  getPlaybookNode
} from "../entities/playbook.js";
import { getAccuracyClassificationForGradingValue } from "./feedbackHelpers.js";
function countIncorrectPlaybookTestNodeExpectations(grading, expectedNodes, assessmentTree) {
  let incorrect = 0;
  Object.entries(grading.criteria_grading ?? {}).forEach(
    ([nodeId, criterionGrade]) => {
      const expectedValue = expectedNodes[nodeId];
      if (!criterionGrade || expectedValue === void 0 || criterionGrade.value === void 0) {
        return;
      }
      const node = getPlaybookNode(nodeId, assessmentTree);
      if (node?.type !== "criteria") {
        return;
      }
      const classification = getAccuracyClassificationForGradingValue(
        node.grading_value_type,
        criterionGrade.value,
        String(expectedValue),
        true
      );
      if (classification === "incorrect") {
        incorrect += 1;
      }
    }
  );
  Object.entries(grading.section_grading ?? {}).forEach(
    ([nodeId, sectionGrade]) => {
      const expectedValue = expectedNodes[nodeId];
      if (!sectionGrade || expectedValue === void 0 || sectionGrade.is_not_applicable === void 0) {
        return;
      }
      const classification = getAccuracyClassificationForGradingValue(
        "section",
        sectionGrade.is_not_applicable ? "N/A" : "applicable",
        String(expectedValue),
        true
      );
      if (classification === "incorrect") {
        incorrect += 1;
      }
    }
  );
  return incorrect;
}
function checkPlaybookTestOutcomeMatch(expectedOutcome, actualOutcome, outcomeDefinition) {
  const { value: expectedValue } = getOutcomeValueAndLabel(
    expectedOutcome,
    outcomeDefinition
  );
  const { value: actualValue } = getOutcomeValueAndLabel(
    actualOutcome,
    outcomeDefinition
  );
  return expectedValue === void 0 || expectedValue === actualValue;
}
function computePlaybookTestVerdict(input) {
  const { assertions, verdicts, nodeIncorrect, outcomeMatches } = input;
  const diagnosticIds = new Set(
    assertions.filter((assertion) => assertion.diagnostic).map((assertion) => assertion.id)
  );
  const applicableVerdicts = verdicts.filter((verdict) => verdict.applicable);
  const gatingVerdicts = applicableVerdicts.filter(
    (verdict) => !diagnosticIds.has(verdict.id)
  );
  const diagnosticVerdicts = applicableVerdicts.filter(
    (verdict) => diagnosticIds.has(verdict.id)
  );
  const gatingPassed = gatingVerdicts.filter(
    (verdict) => verdict.passed
  ).length;
  const passed = outcomeMatches && (assertions.length === 0 || gatingPassed === gatingVerdicts.length && nodeIncorrect === 0);
  return {
    passed,
    gating_passed: gatingPassed,
    gating_applicable: gatingVerdicts.length,
    diagnostics_passed: diagnosticVerdicts.filter((verdict) => verdict.passed).length,
    diagnostics_total: diagnosticVerdicts.length,
    node_incorrect: nodeIncorrect
  };
}
export {
  checkPlaybookTestOutcomeMatch,
  computePlaybookTestVerdict,
  countIncorrectPlaybookTestNodeExpectations
};
//# sourceMappingURL=playbookTestVerdict.js.map
